import React, { useRef, useState } from 'react'
import { IonIcon, IonPopover } from '@ionic/react'
import { searchOutline } from 'ionicons/icons'
import { useDispatch } from 'react-redux'
import './svgRenderer.component.css'

interface ISvgRenderer {
  handleSelect?: (part: any) => void
  onZoomSelect?: (zoomedInPart: any) => void
  svgData: any[]
  viewBox: string
  width?: string
  height?: string
  fill: string | ((part: any) => string)
  className: string
  setZoomButtonVisible?: (option: boolean) => void
  zoomButtonVisible?: boolean
  selectedPart?: any
  showZoom?: boolean
}

const SvgRenderer: React.FC<ISvgRenderer> = ({
  handleSelect,
  onZoomSelect,
  svgData,
  viewBox,
  fill = '',
  className = '',
  setZoomButtonVisible,
  zoomButtonVisible = false,
  selectedPart,
  showZoom,
}) => {
  const svgRef = useRef<SVGSVGElement>(null)
  const [popoverEvent, setPopoverEvent] = useState<MouseEvent | undefined>(undefined)
  const dispatch = useDispatch()

  return (
    <div id='SvgRenderer' className={className}>
      <svg ref={svgRef} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        {svgData.map((svgItem, index) => (
          <g key={index}>
            <path
              onClick={(e) => {
                handleSelect && handleSelect(svgItem)
                setPopoverEvent(e.nativeEvent)
              }}
              d={svgItem.path}
              fill={typeof fill === 'string' ? fill : fill(svgItem)}
              data-id={svgItem.id}
            />
          </g>
        ))}
      </svg>

      {showZoom && (
        <IonPopover
          isOpen={zoomButtonVisible}
          event={popoverEvent}
          onDidDismiss={() => setZoomButtonVisible && dispatch(setZoomButtonVisible(false))}
          className='custom-popover'>
          {selectedPart && (
            <div
              className='zoom-button-overlay'
              onClick={(e) => {
                e.stopPropagation()
                onZoomSelect && onZoomSelect(selectedPart)
              }}>
              <div className='zoom-button'>
                <IonIcon icon={searchOutline} size='large' />
                Zoom
              </div>
            </div>
          )}
        </IonPopover>
      )}
    </div>
  )
}

export default SvgRenderer
